/** 服务费方案 /metering/fee/service-plan（servicePlan.vue） */
export default {
  servicePlanPage: {
    sectionTitle: '服务费方案',
    btnAddPlan: '新增方案',
    emptyTable: '暂无服务费方案数据',
    emptyNoPermission: '暂无查看权限',
    colPlanId: '方案ID',
    colPlanName: '方案名称',
    colPeak: '尖电价(元/度)',
    colTop: '峰电价(元/度)',
    colFlat: '平电价(元/度)',
    colValley: '谷电价(元/度)',
    colUpdated: '更新时间',
    colAction: '操作',
    btnAdjust: '调价',
    btnLog: '日志',
    btnBatchBind: '批量绑定',
    modalTitleEdit: '调整价格',
    modalTitleAdd: '新增方案',
    formPlanName: '方案名称',
    phPlanName: '请输入方案名称',
    labelPeak: '尖电价',
    labelTop: '峰电价',
    labelFlat: '平电价',
    labelValley: '谷电价',
    logLabelPeak: '尖电价：',
    logLabelTop: '峰电价：',
    logLabelFlat: '平电价：',
    logLabelValley: '谷电价：',
    unitPerKwh: '元/度',
    warnEditNote: '注：修改方案会同时更改相应电表计费金额',
    labelPhoneBound: '绑定手机',
    labelVerifyCode: '验证码',
    phVerifyCode: '请输入验证码',
    sendCode: '发送验证码',
    resendIn: '{n} 秒后可重发',
    btnCancel: '取消',
    btnConfirm: '确定',
    drawerTitle: '批量绑定电表',
    tabDedicated: '专用电表',
    tabShare: '公摊电表',
    phSearchMeter: '搜索电表名称',
    selectAll: '全选',
    tagShareGroup: '公摊组',
    tagBound: '已绑定',
    emptyTreeNoMatch: '没有找到匹配的电表',
    emptyTreeNoData: '暂无电表数据',
    selectedMeters: '已选择 {count} 个电表',
    btnConfirmBind: '确认绑定',
    logTitle: '调价日志',
    emptyLog: '暂无调价记录',
    logPlanNameLabel: '方案名称：',
    logPhoneLabel: '操作手机：',
    groupUngrouped: '未分组',
    msgLoadFail: '获取数据失败',
    msgNoOperate: '暂无操作权限',
    msgSmsSent: '验证码已发送',
    msgSmsFail: '发送验证码失败',
    msgVerifyCode: '请输入验证码',
    msgNameRequired: '请输入方案名称',
    msgPriceIncomplete: '请填写完整的电价信息',
    msgPriceZero: '电价不可为0',
    titleTip: '提示',
    btnOk: '确定',
    confirmModify: '确认修改方案？',
    confirmAdd: '确认新增方案？',
    msgOpOk: '操作成功',
    msgOpFail: '操作失败',
    confirmBindMeters: '确认绑定 {count} 个电表到该方案？',
    msgBindOk: '绑定成功',
    msgBindFail: '绑定失败',
    msgSelectMeters: '请选择要绑定的电表',
    msgSelectNewMeters: '请选择新的电表进行绑定',
    msgMeterListFail: '获取电表列表失败',
    msgLogFail: '获取日志失败'
  }
}
